import IDataFilterProps from "./IDataFilterProps";
import DataFilterTextBox from "./textBox/DataFilterTextBox";
import DataFilterEnumCheckBox from "./enumCheckBox/DataFilterEnumCheckBox";
import DataFilterSelectInputBoxCurrency from "./selecBoxCurrency/DataFilterSelectInputBoxCurrency"
import DataFilterRangeBoxCurrency from "./rangeBoxCurrency/DataFilterRangeBoxCurrency";
import DataFilterDateRangeBox from "./dateRangeBox/DataFilterDateRangeBox";
import DataFilterCheckBox from "./checkBox/DataFilterCheckBox";
import DataFilterRangeBox from "./rangeBox/DataFilterRangeBox"
import DataFilterEnumRadioBox from "./enumRadioBox/DataFilterEnumRadioBox";
import DataFilterSelectInputBox from "./selectBox/DataFilterSelectInputBox";
import DataFilterEnumSelectInputBox from "./enumSelectBox/DataFilterEnumSelectInputBox";
import DataFilterRadioInputBox from "./radioBox/DataFilterRadioInputBox";


const TextBox = (props: IDataFilterProps) => DataFilterTextBox(props);

const CheckBox = (props: IDataFilterProps) => DataFilterCheckBox(props);

const EnumCheckBox = (props: IDataFilterProps) => DataFilterEnumCheckBox(props);

const RangeBox = (props: IDataFilterProps) => DataFilterRangeBox(props);

const RangeBoxCurrency = (props: IDataFilterProps) => DataFilterRangeBoxCurrency(props);

const DateRangeBox = (props: IDataFilterProps) => DataFilterDateRangeBox(props);

const EnumRadioBox = (props: IDataFilterProps) => DataFilterEnumRadioBox(props);

const SelectInputBox = (props: IDataFilterProps) => DataFilterSelectInputBox(props);

const EnumSelectInputBox = (props: IDataFilterProps) => DataFilterEnumSelectInputBox(props);

const SelectInputBoxCurrency = (props: IDataFilterProps) => DataFilterSelectInputBoxCurrency(props);

const RadioInputBox = (props: IDataFilterProps) => DataFilterRadioInputBox(props);

export const DataFilterComponentsMapper: any = {
    TextBox,
    CheckBox,
    EnumCheckBox,
    RangeBox,
    RangeBoxCurrency,
    DateRangeBox,
    EnumRadioBox,
    SelectInputBox,
    EnumSelectInputBox,
    SelectInputBoxCurrency,
    RadioInputBox
}